import { render, staticRenderFns } from "./FormInstallmentPlanKTC.vue?vue&type=template&id=635bb34e&scoped=true&"
import script from "./FormInstallmentPlanKTC.vue?vue&type=script&lang=js&"
export * from "./FormInstallmentPlanKTC.vue?vue&type=script&lang=js&"
import style0 from "./FormInstallmentPlanKTC.vue?vue&type=style&index=0&id=635bb34e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635bb34e",
  null
  
)

export default component.exports